// 搜尋頁 - 關鍵字＋結果數量

const SearchKeyword = ({ keyword, resultAmount }) => {
    return (
        <section className="py-[17px] bg-white space-y-[8px] px-[30px] umd:py-[20px] usm:px-[15px]">
            <p className="text-h3 text-black">Search for : {decodeURIComponent(keyword)}</p>
            <p className="text-black3 text-bd4n">There are {resultAmount} results</p>
        </section>
    );
};

export default SearchKeyword;
